import { render, staticRenderFns } from "./instrument.vue?vue&type=template&id=f9f2c868&scoped=true&"
import script from "./instrument.vue?vue&type=script&lang=js&"
export * from "./instrument.vue?vue&type=script&lang=js&"
import style0 from "./instrument.vue?vue&type=style&index=0&id=f9f2c868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f2c868",
  null
  
)

export default component.exports